import type { PartialPreconClientSettings } from './merge-settings';
import { getMeta } from '@precon-tools-suite-by-shared/browser-utils';

export const staticDefaultSettings: PartialPreconClientSettings = {
    app: {
        name: getMeta('app-name') ?? '',
        version: '0.1.0',
        loginWithTeam: true,
        instrumentationKey: getMeta('instrumentation-key'),
    },
    graphql: {
        logRoundTrip: false,
        logErrors: false,
        logWsEvents: false,
        subscriptionsVia: 'graphql-transport-ws',
        batch: {
            debounce: true,
            enabled: false,
            interval: 20,
            max: 10,
        },
    },
    msal: {
        redirectUri: '/',
        postLogoutRedirectUri: '/',
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        cacheLocation: 'sessionStorage',
        policies: {
            login: {
                type: 'tfp',
                extraQueryParameters: {},
            },
            password_reset: {
                type: 'tfp',
                policyName: 'b2c_1a_passwordreset',
                extraQueryParameters: {},
            },
            profile_edit: {
                type: 'tfp',
                policyName: 'b2c_1a_profileedit',
                extraQueryParameters: {},
            },
        },
    },
    backend: {
        timezone: 'UTC',
    },
    pusher: {
        key: 'app-key',
        options: {
            cluster: 'eu',
            disableStats: true,
            enableTransports: ['ws', 'wss'],
            forceTLS: false,
            httpPort: 80,
            httpsPort: 443,
            wsPort: 80,
            wssPort: 443,
        },
    },
};
